import { Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DefaultSwitch from '../../../components/switch/DefaultSwitch'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import TextField from '@material-ui/core/TextField'
import { usePlace } from 'commons/usePlace'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import DialogCreateLandingPage from '../components/DialogCreateLandingPage'
import { makeStyles } from '@material-ui/styles'
import effects from '../../../effects/effects'
import { copyToClipboard } from 'libs/clipboard'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import Button from '@material-ui/core/Button'
import { useAppName } from 'commons/usePartner'
import {
  updateToggleLanding,
  updateLandingCreated,
  updateLandingPlaceName,
} from 'app/store/actions/place.actions'
import * as R from 'ramda'

const LANDING_DIALOG = 'LANDING_DIALOG'

const useStyles = makeStyles({
  landingPrefix: {
    position: 'absolute',
    left: 62,
    top: 18,
    color: '#404040',
    opacity: 0.36,
    zIndex: 1,
  },
  createLandingDialog: {
    '& .MuiDialog-container .MuiPaper-root': {
      width: '100%',
    },
  },
  landingPageButtonWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },
})

export default () => {
  const { curatedInfo } = usePlace()
  const [isLandingPageCreated, setIsLandingPageCreated] = useState(
    curatedInfo.isLandingShow || false,
  )
  const [isLandingCreated, setIsLandingCreated] = useState(
    curatedInfo.isLandingCreated,
  )
  const [alias, setAlias] = useState(curatedInfo.alias)
  const [landingUrl, setLandingUrl] = useState('')
  const [isFirstTime, setIsFirstTime] = useState(R.isNil(curatedInfo.alias))
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const initPageState = {
    isOpenLandingDialog: false,
  }
  const [pageState, setPageState] = useState(initPageState)

  const getEnvData = async () => {
    const { landingPageUrl } = await effects.apis.getEnvData()
    setLandingUrl(`${landingPageUrl}/places/`)
  }

  useEffect(() => {
    getEnvData()
  }, [])

  useEffect(() => {
    setAlias(curatedInfo.alias)
  }, [curatedInfo.alias])

  function toggleDialogs(dialogType, isOpen) {
    if (dialogType === LANDING_DIALOG) {
      setPageState({
        ...pageState,
        isOpenLandingDialog: isOpen,
      })
    }
  }

  const setNewLandingPage = (newAlias) => {
    setAlias(newAlias)
    setIsLandingPageCreated(true)
    dispatch(
      MessageAlert.showSuccess({
        message: formatMessage({
          id: 'profile.info.success',
        }),
      }),
    )
    dispatch(updateLandingPlaceName(newAlias))
  }

  const revertLanding = () => {
    if (!alias) {
      setIsLandingPageCreated(false)
    }
  }

  const copyLanding = (e) => {
    e.stopPropagation()
    dispatch(
      MessageAlert.showSuccess({
        message: formatMessage({
          id: 'copied',
        }),
      }),
    )
    copyToClipboard(`${landingUrl}${alias || ''}`)
  }

  const classes = useStyles()
  const place = usePlace()
  const appName = useAppName()
  const handleCreateLanding = () => {
    effects.apis.createLanding({ placeId: place.id }).then(() => {
      setIsLandingCreated(true)
      dispatch(updateLandingCreated(true))
    })
  }
  const handleToggleLanding = (e) => {
    const valueToggle = e.target.checked
    effects.apis
      .updateShowLanding({
        showLanding: valueToggle,
        placeId: place.id,
      })
      .then(() => {
        dispatch(updateToggleLanding(valueToggle))
      })
    setIsLandingPageCreated(valueToggle)
    toggleDialogs(LANDING_DIALOG, valueToggle)
  }
  const disabledLandigButton =
    !place.info ||
    !place.info.description ||
    place.info.description.length < 100 ||
    place.info.logo === null
  return (
    <>
      <div className="mb-10">
        <FormattedMessage id="landing.hint" values={{ appName }} />
      </div>
      {isLandingCreated === false && (
        <>
          {disabledLandigButton && (
            <div className="mb-10" style={{ color: 'red' }}>
              <FormattedMessage id="no.logo.or.no.description.error.message" />
            </div>
          )}
          <div className={classes.landingPageButtonWrapper}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => handleCreateLanding()}
              disabled={disabledLandigButton}
            >
              <FormattedMessage id="landing.page.button.title" />
            </Button>
          </div>
        </>
      )}
      {isLandingCreated && (
        <div className="flex cursor-default items-center">
          <div className={clsx('flex items-center')}>
            <Typography variant="body2" className="ltr:mr-8 rtl:ml-8">
              <FormattedMessage id="profile.info.show.landing" />
            </Typography>
          </div>
          <DefaultSwitch
            value={isLandingPageCreated}
            checked={isLandingPageCreated}
            onChange={(e) => {
              handleToggleLanding(e)
            }}
          />
        </div>
      )}

      {isLandingPageCreated && (
        <div>
          <TextField
            className="mt-20 w-full"
            disabled={true}
            onClick={() => toggleDialogs(LANDING_DIALOG, true)}
            variant="outlined"
            value={`${landingUrl}${alias || ''}`}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="edit alias">
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="edit alias" onClick={copyLanding}>
                    <FileCopyOutlinedIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      )}
      <DialogCreateLandingPage
        isFirstTime={isFirstTime}
        alias={alias}
        state={pageState}
        classes={classes}
        toggleDialogs={toggleDialogs}
        landingUrl={landingUrl}
        LANDING_DIALOG={LANDING_DIALOG}
        onCreateLanding={setNewLandingPage}
        onCancel={revertLanding}
        onSetFirstTime={() => setIsFirstTime(false)}
      />
    </>
  )
}
